import { render } from "./SocialShare.vue?vue&type=template&id=65218a4f"
import script from "./SocialShare.vue?vue&type=script&lang=js"
export * from "./SocialShare.vue?vue&type=script&lang=js"
script.render = render

export default script